exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.button[data-v-43a77802] {\n  background-color: #526da5 !important;\n  max-height: 75% !important;\n}\n", ""]);

// exports
